// @flow
import React, { Component } from "react";
import MaskedInput from "react-text-mask";
import { phoneNumberMask } from "../../../../Constants/GlobalVariables/InputMasks";
import emailMask from "text-mask-addons/dist/emailMask";

type PropsType = {
  translate: string => void
};

type StateType = {
  contact_form: {
    status: {
      isSubmitted: boolean,
      hasError: boolean,
      isSuccess: boolean
    },
    fields: {
      first_name: string,
      last_name: string,
      email: string,
      phone: string,
      message: string
    }
  }
};

class ContactUnit extends Component<PropsType, StateType> {
  constructor(props: Object) {
    super(props);

    this.state = {
      contact_form: {
        status: {
          isSubmitted: false,
          hasError: false,
          isSuccess: false
        },
        fields: {
          first_name: "",
          last_name: "",
          email: "",
          phone: "",
          message: ""
        }
      }
    };
  }

  _handleFieldChange = (field: string, value: string) => {
    const pseudoState = this.state;
    pseudoState.contact_form.fields[field] = value;
    this.setState(pseudoState);
  };

  _handleContactFormSubmit = () => {
    const pseudoState = this.state;
    pseudoState.contact_form.status.isSubmitted = true;
    pseudoState.contact_form.status.isSuccess = true;
    // pseudoState.contact_form.status.hasError = true;
    this.setState(pseudoState);
    console.log(this.state.contact_form.fields);
  };

  _clearContactFormState = () => {
    const pseudoState = this.state;
    pseudoState.contact_form.status.isSubmitted = false;
    pseudoState.contact_form.status.isSuccess = false;
    pseudoState.contact_form.status.hasError = false;
    this.setState(pseudoState);
  };

  render() {
    const { translate } = this.props;
    const { contact_form } = this.state;
    return (
      <section className="section">
        <div className="container">
          <h2 className="text-center">{translate("ContactPageLocale.contact_unit.title")}</h2>
          <div className="row gap-y mt-8">
            <div className="col-lg-6">
              {contact_form.status.isSubmitted && contact_form.status.isSuccess && !contact_form.status.hasError ? (
                <div className="alert alert-success alert-dismissible fade show">
                  {translate("ContactPageLocale.contact_unit.form_area.success_message")}
                  <button
                    type="button"
                    className="close"
                    onClick={() => {
                      this._clearContactFormState();
                    }}
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              ) : null}
              {contact_form.status.isSubmitted && contact_form.status.hasError && !contact_form.status.isSuccess ? (
                <div className="alert alert-danger alert-dismissible fade show">
                  {translate("ContactPageLocale.contact_unit.form_area.failure_message")}
                  <button
                    type="button"
                    className="close"
                    onClick={() => {
                      this._clearContactFormState();
                    }}
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              ) : null}
              <div className="form-row">
                <div className="form-group col-md-6">
                  <input
                    className="form-control form-control-lg"
                    type="text"
                    value={contact_form.fields.first_name}
                    name="first_name"
                    onChange={event => {
                      this._handleFieldChange(event.target.name, event.target.value);
                    }}
                    placeholder={translate("ContactPageLocale.contact_unit.form_area.first_name")}
                  />
                </div>

                <div className="form-group col-md-6">
                  <input
                    className="form-control form-control-lg"
                    type="text"
                    value={contact_form.fields.last_name}
                    name="last_name"
                    onChange={event => {
                      this._handleFieldChange(event.target.name, event.target.value);
                    }}
                    placeholder={translate("ContactPageLocale.contact_unit.form_area.last_name")}
                  />
                </div>

                <div className="form-group col-md-6">
                  <MaskedInput
                    className="form-control form-control-lg"
                    type="text"
                    value={contact_form.fields.email}
                    name="email"
                    mask={emailMask}
                    onChange={event => {
                      this._handleFieldChange(event.target.name, event.target.value);
                    }}
                    placeholder={translate("ContactPageLocale.contact_unit.form_area.email")}
                  />
                </div>

                <div className="form-group col-md-6">
                  <MaskedInput
                    className="form-control form-control-lg"
                    type="text"
                    value={contact_form.fields.phone}
                    name="phone"
                    guide
                    keepCharPositions
                    mask={phoneNumberMask}
                    onChange={event => {
                      this._handleFieldChange(event.target.name, event.target.value);
                    }}
                    placeholder={translate("ContactPageLocale.contact_unit.form_area.phone")}
                  />
                </div>
              </div>

              <div className="form-group">
                <textarea
                  className="form-control form-control-lg"
                  rows="4"
                  value={contact_form.fields.message}
                  name="message"
                  onChange={event => {
                    this._handleFieldChange(event.target.name, event.target.value);
                  }}
                  placeholder={translate("ContactPageLocale.contact_unit.form_area.message")}
                />
              </div>

              <button
                className="btn btn-lg btn-primary"
                onClick={() => {
                  this._handleContactFormSubmit();
                }}
              >
                {translate("ContactPageLocale.contact_unit.form_area.form_submit")}
              </button>
            </div>

            <div className="col-lg-5 ml-auto text-center text-lg-left">
              <hr className="d-lg-none" />
              <h5>{translate("ContactPageLocale.information_unit.address.header")}</h5>
              <p>{translate("ContactPageLocale.information_unit.address.content")}</p>
              <p>{translate("ContactPageLocale.information_unit.address.subcontent")}</p>
              <p>{translate("ContactPageLocale.information_unit.address.email")}</p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ContactUnit;



// WEBPACK FOOTER //
// ./src/Components/PublicPages/Components/ContactPage/ContactUnit.js